import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import Checkbox from '../../checkbox/Checkbox';
import type { EnhancedItem } from '../hooks/useEnhancedItems';
import { GroupHeaderItem as GroupHeaderItemStyled } from '../SharedStyledComponents';
import type { GroupItem, DownshiftItemProps } from '../types';

type GroupHeaderItemComponentProps = {
  enhancedItem: EnhancedItem<unknown> & { itemType: 'groupLabel' };
  isHighlighted: boolean;
  showCheckbox: boolean;
  customRenderMenuItemGroupLabel?: (item: GroupItem) => ReactNode;
  itemProps: DownshiftItemProps;
};

/**
 * Component for rendering a group header menu item
 */
export const GroupHeaderItemComponent = ({
  enhancedItem,
  isHighlighted,
  showCheckbox,
  customRenderMenuItemGroupLabel,
  itemProps,
}: GroupHeaderItemComponentProps) => {
  const renderGroupLabel = (): ReactNode => {
    if (customRenderMenuItemGroupLabel) {
      return customRenderMenuItemGroupLabel({
        label: enhancedItem.label,
        itemType: 'groupLabel',
      });
    }
    return enhancedItem.label;
  };

  return (
    <GroupHeaderItemStyled
      data-testid={`group-header-${enhancedItem.label}`}
      data-selected={enhancedItem.isSelected}
      isDisabled={enhancedItem.isDisabled}
      isHighlighted={isHighlighted}
      isSelected={enhancedItem.isSelected}
      key={itemProps.id}
      {...itemProps}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap="8px"
        sx={{
          overflowWrap: 'anywhere',
        }}
      >
        {showCheckbox && (
          <Checkbox
            checked={enhancedItem.isSelected}
            disabled={enhancedItem.isDisabled}
            indeterminate={enhancedItem.isIndeterminate}
            testId="checkbox"
          />
        )}
        {renderGroupLabel()}
      </Stack>
    </GroupHeaderItemStyled>
  );
};
